import { render, staticRenderFns } from "./KoPollutants.vue?vue&type=template&id=7fa29f66"
import script from "./KoPollutants.vue?vue&type=script&lang=js"
export * from "./KoPollutants.vue?vue&type=script&lang=js"
import style0 from "./KoPollutants.vue?vue&type=style&index=0&id=7fa29f66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports